import React, { useContext, useEffect, useState } from "react";
import Select from 'react-select';
import { Context } from "./Context";
import { Alert, Button } from "react-bootstrap";
import LoadingSpinner from "./Visuals";
import Multiselect from 'multiselect-react-dropdown';
import getUrl from "../tools/get-domain";

export function MultiSelectDropdown(props) {
    const options = [{ 'value': '12901875871456398', 'label': 'ولراز' }, {
        'value': '66315581735594751',
        'label': 'توسن'
    }, { 'value': '65671173927025645', 'label': 'کتوکا' }, {
        'value': '27668158733246204',
        'label': 'سپرمی'
    }, { 'value': '60289595205403229', 'label': 'بهیر' }, {
        'value': '54482686501491508',
        'label': 'زبینا'
    }, { 'value': '53999651992586159', 'label': 'ثپردیس' }, {
        'value': '47756003257788498',
        'label': 'حگهر'
    }, { 'value': '47563321799863211', 'label': 'بتهران' }, {
        'value': '43291783149314349',
        'label': 'وسرمد'
    }, { 'value': '52455922800537930', 'label': 'تکنار' }, {
        'value': '40411537531154482',
        'label': 'قصفها'
    }, { 'value': '57600064931636077', 'label': 'وجامی' }, {
        'value': '1822787329898392',
        'label': 'کلر'
    }, { 'value': '69171897374421261', 'label': 'فن افزار' }, {
        'value': '42049553761321495',
        'label': 'کورز'
    }, { 'value': '30703140537034664', 'label': 'کگهر' }, {
        'value': '37389789764168256',
        'label': 'توریل'
    }, { 'value': '55254206302462116', 'label': 'آپ' }, {
        'value': '71957984642204570',
        'label': 'شپترو'
    }, { 'value': '42387718866026650', 'label': 'غبشهر' }, {
        'value': '25336820825905643',
        'label': 'ونیکی'
    }, { 'value': '60783654574662426', 'label': 'وهنر' }, {
        'value': '69472361926040823',
        'label': 'ویسا'
    }, { 'value': '38568786927478796', 'label': 'شیراز' }, {
        'value': '27096851668435724',
        'label': 'جم پیلن'
    }, { 'value': '29758477602878557', 'label': 'تیپیکو' }, {
        'value': '24303422207378456',
        'label': 'غالبر'
    }, { 'value': '12777578088653944', 'label': 'وحکمت' }, {
        'value': '55959112038778737',
        'label': 'سخواف'
    }, { 'value': '2400322364771558', 'label': 'شستا' }, {
        'value': '44296315953738727',
        'label': 'فاهواز'
    }, { 'value': '17059960254855208', 'label': 'غبهنوش' }, {
        'value': '66295665969375744',
        'label': 'سبجنو'
    }, { 'value': '28431095903407567', 'label': 'کاسپین' }, {
        'value': '28033133021443774',
        'label': 'خفنر'
    }, { 'value': '36671655475498480', 'label': 'قشرین' }, {
        'value': '41781090739318251',
        'label': 'تلیسه'
    }, { 'value': '47348197320716810', 'label': 'دسانکو' }, {
        'value': '68517032834363488',
        'label': 'شبصیر'
    }, { 'value': '16410724132711490', 'label': 'غفارس' }, {
        'value': '43781018754867729',
        'label': 'شفارس'
    }, { 'value': '60654872678917533', 'label': 'سقاین' }, {
        'value': '67030488744129337',
        'label': 'قپیرا'
    }, { 'value': '25180702353416009', 'label': 'زدشت' }, {
        'value': '51971068201094874',
        'label': 'بپاس'
    }, { 'value': '45062188442385800', 'label': 'تفیرو' }, {
        'value': '3863538898378476',
        'label': 'ثمسکن'
    }, { 'value': '46982154647719707', 'label': 'وصنا' }, {
        'value': '32845891587040106',
        'label': 'ثنوسا'
    }, { 'value': '58482817740704549', 'label': 'خکرمان' }, {
        'value': '28147934478934110',
        'label': 'فغدیر'
    }, { 'value': '14427168056799610', 'label': 'کیمیا' }, {
        'value': '2944500421562364',
        'label': 'وتوصا'
    }, { 'value': '28328083629154916', 'label': 'سجام' }, {
        'value': '25215182208950217',
        'label': 'وهور'
    }, { 'value': '59848307608894801', 'label': 'گپارس' }, {
        'value': '19060477008033661',
        'label': 'پارسان2'
    }, { 'value': '57086055330734195', 'label': 'کرازی' }, {
        'value': '62404730109947970',
        'label': 'غکورش'
    }, { 'value': '52382684379473036', 'label': 'دکپسول' }, {
        'value': '34641719089573667',
        'label': 'دتماد'
    }, { 'value': '4373573287489723', 'label': 'وامین' }, {
        'value': '48457557221009333',
        'label': 'وتوسکا'
    }, { 'value': '31078457170311964', 'label': 'ولشرق' }, {
        'value': '44052047028305231',
        'label': 'پشاهن'
    }, { 'value': '52593789542874668', 'label': 'پلاست' }, {
        'value': '55201604487356053',
        'label': 'فن آوا'
    }, { 'value': '67690708346979840', 'label': 'کماسه' }, {
        'value': '18303237082155264',
        'label': 'دفرا'
    }, { 'value': '23293437377896568', 'label': 'تاصیکو' }, {
        'value': '24085906177899789',
        'label': 'کترام'
    }, { 'value': '778253364357513', 'label': 'وبملت' }, {
        'value': '49641108336531623',
        'label': 'انرژی'
    }, { 'value': '10171945867136336', 'label': 'سیتا' }, {
        'value': '29882244560576007',
        'label': 'بزاگرس'
    }, { 'value': '32347247706508046', 'label': 'ساوه' }, {
        'value': '10055255678920880',
        'label': 'وملت'
    }, { 'value': '67988012428906654', 'label': 'دارو' }, {
        'value': '32821908911812078',
        'label': 'خزر'
    }, { 'value': '45392752356003555', 'label': 'صبا' }, {
        'value': '22903901709044823',
        'label': 'ختراک'
    }, { 'value': '917857106093847', 'label': 'حپارسا' }, {
        'value': '70289374539527245',
        'label': 'ختوقا'
    }, { 'value': '41379697187196382', 'label': 'وشهر' }, {
        'value': '10568944722570445',
        'label': 'سصفها'
    }, { 'value': '47797676603278665', 'label': 'بازرگام' }, {
        'value': '71510396252618330',
        'label': 'دبالک'
    }, { 'value': '22260326095996531', 'label': 'حتوکا' }, {
        'value': '39751275523025334',
        'label': 'اتکای'
    }, { 'value': '48753732042176709', 'label': 'شبریز' }, {
        'value': '5866848234665627',
        'label': 'دسبحان'
    }, { 'value': '29590002988360984', 'label': 'سپیدار' }, {
        'value': '37631109616997982',
        'label': 'قشهد'
    }, { 'value': '68488673556087148', 'label': 'فپنتا' }, {
        'value': '35331248532537562',
        'label': 'اردستان'
    }, { 'value': '68635710163497089', 'label': 'همراه' }, {
        'value': '21096748051392414',
        'label': 'سغدیر'
    }, { 'value': '34032872653290886', 'label': 'غپاک' }, {
        'value': '64842837716888827',
        'label': 'خکاوه'
    }, { 'value': '59607545337891226', 'label': 'پرداخت' }, {
        'value': '11129387075131725',
        'label': 'تملت'
    }, { 'value': '68117765376081366', 'label': 'وتوس' }, {
        'value': '20411759370751096',
        'label': 'کنور'
    }, { 'value': '50117925085549635', 'label': 'خلیبل' }, {
        'value': '41122066907413786',
        'label': 'چخزر'
    }, { 'value': '47377315952751604', 'label': 'بسویچ' }, {
        'value': '22087269603540841',
        'label': 'وپست'
    }, { 'value': '40650252484299134', 'label': 'ثاژن' }, {
        'value': '29747059672582491',
        'label': 'سهرمز'
    }, { 'value': '6433335428452486', 'label': 'خعمرا' }, {
        'value': '14079693677610396',
        'label': 'اسیاتک'
    }, { 'value': '57639364758870873', 'label': 'کپشیر' }, {
        'value': '8977441217024425',
        'label': 'فسپا'
    }, { 'value': '8234855558996646', 'label': 'غدانه' }, {
        'value': '30507152381699953',
        'label': 'ثجوان'
    }, { 'value': '57273529732791251', 'label': 'خموتور' }, {
        'value': '59750654860162208',
        'label': 'شیران2'
    }, { 'value': '12746730665870442', 'label': 'بهپاک' }, {
        'value': '1301069819790264',
        'label': 'تجلی'
    }, { 'value': '41284516796232939', 'label': 'سهگمت' }, {
        'value': '18093681647131179',
        'label': 'دتولید'
    }, { 'value': '62346804681275278', 'label': 'کگاز' }, {
        'value': '19367527798307032',
        'label': 'فالوم'
    }, { 'value': '7385624172574740', 'label': 'ورنا' }, {
        'value': '7300125658580126',
        'label': 'زکشت'
    }, { 'value': '4585123877892473', 'label': 'شستا2' }, {
        'value': '12490072956930435',
        'label': 'مدیریت'
    }, { 'value': '23837844039713715', 'label': 'کفرا' }, {
        'value': '8977369674477111',
        'label': 'کطبس'
    }, { 'value': '43374709930371268', 'label': 'دحاوی' }, {
        'value': '64341992373049080',
        'label': 'سدبیر'
    }, { 'value': '51617145873056483', 'label': 'شتران' }, {
        'value': '50633804639547462',
        'label': 'کمرجان'
    }, { 'value': '31460137466631313', 'label': 'میهن2' }, {
        'value': '2589887561569709',
        'label': 'خزامیا'
    }, { 'value': '114312662654155', 'label': 'وسپهر' }, {
        'value': '66021783818850713',
        'label': 'فافزا'
    }, { 'value': '7920014658832193', 'label': 'وگردش' }, {
        'value': '15374483986949695',
        'label': 'دهدشت'
    }, { 'value': '43545527030854340', 'label': 'کویر' }, {
        'value': '611986653700161',
        'label': 'سبزوا'
    }, { 'value': '33603212156438463', 'label': 'دشیمی' }, {
        'value': '50341528161302545',
        'label': 'کمنگنز'
    }, { 'value': '63084741752814852', 'label': 'دشیری' }, {
        'value': '41796741644273824',
        'label': 'وملی'
    }, { 'value': '34621618468546063', 'label': 'ولتجار' }, {
        'value': '60350996279289099',
        'label': 'کاوه'
    }, { 'value': '56006915451245411', 'label': 'لخانه' }, {
        'value': '4733285133017464',
        'label': 'فخاس'
    }, { 'value': '28864540805361867', 'label': 'فخوز' }, {
        'value': '50792786683910016',
        'label': 'کرمان'
    }, { 'value': '6131290133202745', 'label': 'غمهرا' }, {
        'value': '64619251116188373',
        'label': 'بپیوند'
    }, { 'value': '22255783119783047', 'label': 'درازک' }, {
        'value': '63315013743060811',
        'label': 'ثنور'
    }, { 'value': '28450080638096732', 'label': 'سیمرغ' }, {
        'value': '18027801615184692',
        'label': 'کچاد'
    }, { 'value': '26824673819862694', 'label': 'خبهمن' }, {
        'value': '5317427172344706',
        'label': 'هجرت'
    }, { 'value': '28328710198554144', 'label': 'وبوعلی' }, {
        'value': '35964395659427029',
        'label': 'قشکر'
    }, { 'value': '33783140337377394', 'label': 'خچرخش' }, {
        'value': '56820995669577571',
        'label': 'قلرست'
    }, { 'value': '44818950263583523', 'label': 'دی' }, {
        'value': '1625149423498289',
        'label': 'حسینا'
    }, { 'value': '59142194115401696', 'label': 'لوتوس' }, {
        'value': '53204330224889981',
        'label': 'تبرک'
    }, { 'value': '31879190587976736', 'label': 'خوساز' }, {
        'value': '37281199178613855',
        'label': 'سیدکو'
    }, { 'value': '56324206651661881', 'label': 'فنورد' }, {
        'value': '6110133418282108',
        'label': 'پارس'
    }, { 'value': '12965822877128721', 'label': 'ثقزوی' }, {
        'value': '52232388263291380',
        'label': 'وامید'
    }, { 'value': '13281937213456378', 'label': 'حسیر' }, {
        'value': '33729164898197325',
        'label': 'فروسیل2'
    }, { 'value': '59461185672081215', 'label': 'غمایه' }, {
        'value': '7183333492448248',
        'label': 'وپخش'
    }, { 'value': '62177651435283872', 'label': 'شکلر' }, {
        'value': '44625249840480397',
        'label': 'حآسا'
    }, { 'value': '56717416662584054', 'label': 'وکادو' }, {
        'value': '15726796686853780',
        'label': 'ثعمرا'
    }, { 'value': '33441514568901717', 'label': 'میدکو' }, {
        'value': '44967158778304588',
        'label': 'قثابت'
    }, { 'value': '13937270451301973', 'label': 'وبشهر' }, {
        'value': '54493234408301135',
        'label': 'بنو'
    }, { 'value': '6478064539164167', 'label': 'ریشمک' }, {
        'value': '58931793851445922',
        'label': 'ومعادن'
    }, { 'value': '69446612239102459', 'label': 'شکام' }, {
        'value': '12303918642491681',
        'label': 'زنجان'
    }, { 'value': '61664227282090067', 'label': 'سلار' }, {
        'value': '6506179926371994',
        'label': 'آریان'
    }, { 'value': '10654052153538617', 'label': 'کابگن' }, {
        'value': '55289848471625247',
        'label': 'پرسپولیس'
    }, { 'value': '26547785441834730', 'label': 'زشریف' }, {
        'value': '24212636157410845',
        'label': 'وآرین'
    }, { 'value': '53334304751609770', 'label': 'حگردش' }, {
        'value': '66726992874614788',
        'label': 'دتوزیع'
    }, { 'value': '62786156501584862', 'label': 'پاکشو' }, {
        'value': '52792903131341205',
        'label': 'افرا'
    }, { 'value': '11403770140000603', 'label': 'ولملت' }, {
        'value': '23214828924506640',
        'label': 'پکرمان'
    }, { 'value': '33541897671561960', 'label': 'واتی' }, {
        'value': '3623921205367364',
        'label': 'کدما'
    }, { 'value': '45050389997905274', 'label': 'وسینا' }, {
        'value': '16405556680571453',
        'label': 'کخاک'
    }, { 'value': '64155926828410021', 'label': 'ساذری' }, {
        'value': '58035444268544991',
        'label': 'سمتاز'
    }, { 'value': '30852391633490755', 'label': 'ثفارس' }, {
        'value': '22811176775480091',
        'label': 'اخابر'
    }, { 'value': '47996917271187218', 'label': 'وکار' }, {
        'value': '37204371816016200',
        'label': 'وصندوق'
    }, { 'value': '45507655586782998', 'label': 'فجهان' }, {
        'value': '3839324986781871',
        'label': 'تپسی'
    }, { 'value': '15917865009187760', 'label': 'مادیرا' }, {
        'value': '48261930411425125',
        'label': 'بمولد'
    }, { 'value': '6847536925606808', 'label': 'ومعلم' }, {
        'value': '59839275647597021',
        'label': 'وثوق'
    }, { 'value': '2434703913394836', 'label': 'غدشت' }, {
        'value': '39116664428676213',
        'label': 'شلعاب'
    }, { 'value': '16422980660132735', 'label': 'لطیف' }, {
        'value': '63915926161403347',
        'label': 'خشرق'
    }, { 'value': '51294484197536070', 'label': 'غشوکو' }, {
        'value': '25020657188512139',
        'label': 'مرقام'
    }, { 'value': '46178280540110577', 'label': 'بفجر' }, {
        'value': '30650426998863332',
        'label': 'لبوتان'
    }, { 'value': '48511238766369097', 'label': 'دانا' }, {
        'value': '70498485598181604',
        'label': 'هرمز'
    }, { 'value': '57875847776839336', 'label': 'فنوال' }, {
        'value': '25357135030606405',
        'label': 'تنوین'
    }, { 'value': '2254054929817435', 'label': 'غدام' }, {
        'value': '59217041815333317',
        'label': 'خکار'
    }, { 'value': '71483646978964608', 'label': 'ذوب' }, {
        'value': '59342912854668427',
        'label': 'فنفت'
    }, { 'value': '51459202425114449', 'label': 'تابا' }, {
        'value': '33629260529503413',
        'label': 'بجهرم'
    }, { 'value': '47749661205825616', 'label': 'سیستم' }, {
        'value': '3493306453706327',
        'label': 'شوینده'
    }, { 'value': '22086876724551482', 'label': 'بموتو' }, {
        'value': '22308305646551497',
        'label': 'تپولا'
    }, { 'value': '14398278072324784', 'label': 'قهکمت' }, {
        'value': '66643284949247248',
        'label': 'تکیمیا'
    }, { 'value': '35424116338766901', 'label': 'حفارس' }, {
        'value': '70391097626818082',
        'label': 'گشان'
    }, { 'value': '48010225447410247', 'label': 'وبانک' }, {
        'value': '58741071099161284',
        'label': 'فرابورس'
    }, { 'value': '40505767672724777', 'label': 'رانفور' }, {
        'value': '55127657985997520',
        'label': 'آریا'
    }, { 'value': '23122854941568245', 'label': 'خبهمن2' }, {
        'value': '56550776668133562',
        'label': 'دفارا'
    }, { 'value': '30974710508383145', 'label': 'شسینا' }, {
        'value': '44549439964296944',
        'label': 'کالا'
    }, { 'value': '50185721305191887', 'label': 'ختور' }, {
        'value': '24079409192818584',
        'label': 'پدرخش'
    }, { 'value': '61506294208022391', 'label': 'غشصفا' }, {
        'value': '65883838195688438',
        'label': 'خودرو'
    }, { 'value': '22787503301679573', 'label': 'کروی' }, {
        'value': '5920901446678689',
        'label': 'وتعاون'
    }, { 'value': '20966291817819448', 'label': 'فسدید' }, {
        'value': '44891482026867833',
        'label': 'خساپا'
    }, { 'value': '66127247173352975', 'label': 'تشتاد' }, {
        'value': '65004959184388996',
        'label': 'فایرا'
    }, { 'value': '56798822689379375', 'label': 'حاریا' }, {
        'value': '63704201144621295',
        'label': 'حبندر'
    }, { 'value': '47232550823972469', 'label': 'وتوکا' }, {
        'value': '60451823714332895',
        'label': 'دالبر'
    }, { 'value': '39610074039667804', 'label': 'قرن' }, {
        'value': '68909035712962732',
        'label': 'ثباغ'
    }, { 'value': '23374429962331387', 'label': 'کتوسعه' }, {
        'value': '67126881188552864',
        'label': 'رمپنا'
    }, { 'value': '655060129740445', 'label': 'اپال' }, {
        'value': '32577525476436242',
        'label': 'پلوله2'
    }, { 'value': '3050342257199174', 'label': 'قنقش' }, {
        'value': '45519261544951819',
        'label': 'سپید'
    }, { 'value': '27308217070238237', 'label': 'شکربن' }, {
        'value': '64707090254488560',
        'label': 'ثعتما'
    }, { 'value': '72044846109864381', 'label': 'پارتا' }, {
        'value': '67327029014085707',
        'label': 'سخزر'
    }, { 'value': '33611155027418901', 'label': 'غشهداب' }, {
        'value': '27148572013604038',
        'label': 'وفتخار'
    }, { 'value': '42696242981550091', 'label': 'کصدف' }, {
        'value': '46741025610365786',
        'label': 'سمگا'
    }, { 'value': '4159532151694984', 'label': 'فبستم' }, {
        'value': '49353447565507376',
        'label': 'کاذر'
    }, { 'value': '26882843763780650', 'label': 'باران' }, {
        'value': '16673205196919832',
        'label': 'شفارا'
    }, { 'value': '4942127026063388', 'label': 'کاما' }, {
        'value': '58963817688181686',
        'label': 'فن افزار2'
    }, { 'value': '55897939403232751', 'label': 'لسرما' }, {
        'value': '39481233087768672',
        'label': 'نیرو'
    }, { 'value': '40553302624764543', 'label': 'وکغدیر' }, {
        'value': '70309338813767186',
        'label': 'فکمند'
    }, { 'value': '18401147983387689', 'label': 'غپینو' }, {
        'value': '64485827086284311',
        'label': 'فجوش'
    }, { 'value': '12874072841236826', 'label': 'فسازان' }, {
        'value': '65414507129586385',
        'label': 'لخزر'
    }, { 'value': '35515916857426389', 'label': 'قتربت' }, {
        'value': '11622051128546106',
        'label': 'شپاکسا'
    }, { 'value': '7395271748414592', 'label': 'وخارزم' }, {
        'value': '54419429862704331',
        'label': 'فروس'
    }, { 'value': '11964419322927535', 'label': 'سرود' }, {
        'value': '27952969918967492',
        'label': 'رکیش'
    }, { 'value': '831325835570803', 'label': 'ثنام' }, {
        'value': '63830424809501048',
        'label': 'اپرداز'
    }, { 'value': '64298008532791199', 'label': 'ساینا' }, {
        'value': '9141577977527107',
        'label': 'وایرا'
    }, { 'value': '43256212620530446', 'label': 'کبافق' }, {
        'value': '53113471126689455',
        'label': 'چکارن'
    }, { 'value': '28291104595448527', 'label': 'کزغال' }, {
        'value': '19954896371640204',
        'label': 'وزمین'
    }, { 'value': '70219663893822560', 'label': 'بکاب' }, {
        'value': '3173544097113770',
        'label': 'شستان'
    }, { 'value': '60162288821230099', 'label': 'تماوند' }, {
        'value': '12329519546621752',
        'label': 'چدن'
    }, { 'value': '43716452378323683', 'label': 'فزرین' }, {
        'value': '43951910415124966',
        'label': 'وگستر'
    }, { 'value': '33808206014018431', 'label': 'سمازن' }, {
        'value': '53686258677793038',
        'label': 'وارس'
    }, { 'value': '58873907630765023', 'label': 'امین' }, {
        'value': '35366681030756042',
        'label': 'شبندر'
    }, { 'value': '35700344742885862', 'label': 'کگل' }, {
        'value': '22956708386610464',
        'label': 'خودکفا'
    }, { 'value': '7457232989848872', 'label': 'خمحور' }, {
        'value': '16553062355259729',
        'label': 'بمیلا'
    }, { 'value': '2328862017676109', 'label': 'وسپه' }, {
        'value': '4686607974846832',
        'label': 'سفارود'
    }, { 'value': '21432551703060846', 'label': 'حآفرین' }, {
        'value': '53449700212786324',
        'label': 'مارون'
    }, { 'value': '26997316501080743', 'label': 'سشرق' }, {
        'value': '17617474823279712',
        'label': 'آ س پ'
    }, { 'value': '33931218652865616', 'label': 'ونفت' }, {
        'value': '59612098290740355',
        'label': 'آباد'
    }, { 'value': '15930821245168534', 'label': 'سکارون' }, {
        'value': '5427792638736934',
        'label': 'زفکا'
    }, { 'value': '7503669593172728', 'label': 'ثاصفا' }, {
        'value': '7711282667602555',
        'label': 'شاراک'
    }, { 'value': '64973252728260903', 'label': 'وکبهمن' }, {
        'value': '66772024744156373',
        'label': 'فباهنر'
    }, { 'value': '13235547361447092', 'label': 'زاگرس' }, {
        'value': '22275596386264204',
        'label': 'کوثر'
    }, { 'value': '61978776664766359', 'label': 'غپونه' }, {
        'value': '4369934250728330',
        'label': 'غزر'
    }, { 'value': '27218386411183410', 'label': 'سدور' }, {
        'value': '19298748452450329',
        'label': 'تایرا'
    }, { 'value': '45608932669358493', 'label': 'کایتا' }, {
        'value': '67206358287598044',
        'label': 'کهمدا'
    }, { 'value': '65283501585402124', 'label': 'فنفت2' }, {
        'value': '23269285154135003',
        'label': 'جوین'
    }, { 'value': '8725363201030474', 'label': 'فگستر' }, {
        'value': '22950683624908253',
        'label': 'نتوس'
    }, { 'value': '66599109405217136', 'label': 'گکوثر' }, {
        'value': '14744445176220774',
        'label': 'ثبهساز'
    }, { 'value': '71666521540545716', 'label': 'غبهار' }, {
        'value': '52932092555708556',
        'label': 'تکاردان'
    }, { 'value': '44850033148208596', 'label': 'غچین' }, {
        'value': '30443839313522574',
        'label': 'حرهشا'
    }, { 'value': '44013656953678055', 'label': 'شرانل' }, {
        'value': '22382156782768756',
        'label': 'بکام'
    }, { 'value': '57300230097485720', 'label': 'غگیلا' }, {
        'value': '42690477960659940',
        'label': 'کشرق'
    }, { 'value': '32784604551756178', 'label': 'پیزد' }, {
        'value': '45066064863062755',
        'label': 'ثنظام'
    }, { 'value': '62952165421099192', 'label': 'بالبر' }, {
        'value': '3149396562827132',
        'label': 'وایران'
    }, { 'value': '55862580907068610', 'label': 'شملی' }, {
        'value': '27405735172634593',
        'label': 'اتکام'
    }, { 'value': '43913530989262989', 'label': 'سمایه' }, {
        'value': '7745894403636165',
        'label': 'شپنا'
    }, { 'value': '62977319271289925', 'label': 'کی بی سی' }, {
        'value': '14031158866706953',
        'label': 'شراز'
    }, { 'value': '10411249540376641', 'label': 'ناما' }, {
        'value': '56375665074210467',
        'label': 'فسوژ'
    }, { 'value': '59921975187856916', 'label': 'غشاذر' }, {
        'value': '14617104402836487',
        'label': 'سیلام'
    }, { 'value': '45641540066710190', 'label': 'لکما' }, {
        'value': '35669480110084448',
        'label': 'سپاها'
    }, { 'value': '29247915161590165', 'label': 'دلقما' }, {
        'value': '49674915481184052',
        'label': 'جهرم'
    }, { 'value': '17330546482145553', 'label': 'خمهر' }, {
        'value': '17834623106317041',
        'label': 'خنصیر'
    }, { 'value': '13243992182070788', 'label': 'درهآور' }, {
        'value': '18063426072758458',
        'label': 'وبهمن'
    }, { 'value': '17269972595370241', 'label': 'وآتوس' }, {
        'value': '35948133957468680',
        'label': 'سرچشمه'
    }, { 'value': '22276798221643766', 'label': 'تفارس' }, {
        'value': '26543014712914772',
        'label': 'میهن'
    }, { 'value': '3722699128879020', 'label': 'حتاید' }, {
        'value': '24785665268004766',
        'label': 'وپویا'
    }, { 'value': '45518744711972166', 'label': 'غپآذر' }, {
        'value': '318005355896147',
        'label': 'فسا'
    }, { 'value': '67170215467608124', 'label': 'زنگان' }, {
        'value': '59486059679335017',
        'label': 'وپترو'
    }, { 'value': '4384288570322406', 'label': 'دلر' }, {
        'value': '49054891736433700',
        'label': 'دعبید'
    }, { 'value': '4267564158935326', 'label': 'قیستو' }, {
        'value': '21772258644715569',
        'label': 'شغدیر'
    }, { 'value': '26025177574491991', 'label': 'شلیا' }, {
        'value': '21501758781665781',
        'label': 'غمارگ'
    }, { 'value': '63965059137798192', 'label': 'فنرژی' }, {
        'value': '30719054967088301',
        'label': 'تکمبا'
    }, { 'value': '34673681828119297', 'label': 'فاما' }, {
        'value': '20652241232631918',
        'label': 'نیان'
    }, { 'value': '23441366113375722', 'label': 'پارسان' }, {
        'value': '4247709727327181',
        'label': 'مفاخر'
    }, { 'value': '32357363984168442', 'label': 'جم' }, {
        'value': '5054819322815158',
        'label': 'زمگسا'
    }, { 'value': '42075223783409640', 'label': 'خاذین' }, {
        'value': '47302318535715632',
        'label': 'ونوین'
    }, { 'value': '66830065858417081', 'label': 'ولانا' }, {
        'value': '31049085025064185',
        'label': 'شتهران'
    }, { 'value': '45991797190214892', 'label': 'وآفر' }, {
        'value': '34213522001938649',
        'label': 'عالیس'
    }, { 'value': '20926459161497908', 'label': 'ثتران' }, {
        'value': '66701874099226162',
        'label': 'فاسمین'
    }, { 'value': '9761381741308262', 'label': 'وشمال' }, {
        'value': '8915450910866216',
        'label': 'دزهراوی'
    }, { 'value': '71523986304961239', 'label': 'قشیر' }, {
        'value': '14916489896692147',
        'label': 'زملارد'
    }, { 'value': '46752599569017089', 'label': 'بترانس' }, {
        'value': '33854964748757477',
        'label': 'رنیک'
    }, { 'value': '62603302940123327', 'label': 'ونیرو' }, {
        'value': '36899214178084525',
        'label': 'شفا'
    }, { 'value': '22427604495160869', 'label': 'تمحرکه' }, {
        'value': '8175784894140974',
        'label': 'فزر'
    }, { 'value': '31791737198597563', 'label': 'غشان' }, {
        'value': '29974853866926823',
        'label': 'فروی'
    }, { 'value': '36773155987365094', 'label': 'اعتلا' }, {
        'value': '39436183727126211',
        'label': 'خمحرکه'
    }, { 'value': '23600798892801694', 'label': 'قچار' }, {
        'value': '62107151670661969',
        'label': 'بکابل'
    }, { 'value': '43062880954780884', 'label': 'تپمپی' }, {
        'value': '4885314541377431',
        'label': 'حپرتو'
    }, { 'value': '16369313804633525', 'label': 'حپترو' }, {
        'value': '50368344235826302',
        'label': 'لازما'
    }, { 'value': '7483280423474368', 'label': 'خاهن' }, {
        'value': '27922860956133067',
        'label': 'مبین'
    }, { 'value': '47026464823464687', 'label': 'ومهان' }, {
        'value': '16959429956899455',
        'label': 'شاملا'
    }, { 'value': '65018804181564924', 'label': 'گوهران' }, {
        'value': '41625340598198551',
        'label': 'بساما'
    }, { 'value': '41935584690956944', 'label': 'پتایر' }, {
        'value': '48619517949257749',
        'label': 'غنوش'
    }, { 'value': '5516102131364383', 'label': 'غمینو' }, {
        'value': '28251956446987982',
        'label': 'شمواد'
    }, { 'value': '37842793167868642', 'label': 'غویتا' }, {
        'value': '37614886280396031',
        'label': 'وساپا'
    }, { 'value': '16693610252404739', 'label': 'ثالوند' }, {
        'value': '26014913469567886',
        'label': 'وغدیر'
    }, { 'value': '67467233352325215', 'label': 'وگردش2' }, {
        'value': '20453828618330936',
        'label': 'بنیرو'
    }, { 'value': '67213778593531096', 'label': 'وامیر' }, {
        'value': '12638840758449459',
        'label': 'پخش'
    }, { 'value': '56574323121551263', 'label': 'شکبیر' }, {
        'value': '19348717261145458',
        'label': 'وهامون'
    }, { 'value': '31024260997481994', 'label': 'غگرجی' }, {
        'value': '28672095850798501',
        'label': 'غسالم'
    }, { 'value': '18004480270695404', 'label': 'فمراد' }, {
        'value': '44846320603450383',
        'label': 'فروسیل'
    }, { 'value': '60633055620418060', 'label': 'فلات' }, {
        'value': '6757220448540984',
        'label': 'سشمال'
    }, { 'value': '2318736941376687', 'label': 'خصدرا' }, {
        'value': '9698674686691945',
        'label': 'کپارس'
    }, { 'value': '48287670503317419', 'label': 'ولبهمن' }, {
        'value': '34540569618314880',
        'label': 'قاسم'
    }, { 'value': '22560050433388046', 'label': 'تاپیکو' }, {
        'value': '48990026850202503',
        'label': 'خگستر'
    }, { 'value': '61102694810476197', 'label': 'شپارس' }, {
        'value': '37661500521100963',
        'label': 'آبادا'
    }, { 'value': '46348559193224090', 'label': 'فولاد' }, {
        'value': '45174198424472334',
        'label': 'ولساپا'
    }, { 'value': '38084304113529336', 'label': 'خدیزل' }, {
        'value': '61497037864214396',
        'label': 'وکغدیر2'
    }, { 'value': '14312030900097668', 'label': 'غگلپا' }, {
        'value': '35543935713999309',
        'label': 'تاتمس'
    }, { 'value': '41302553376174581', 'label': 'فجر' }, {
        'value': '34610263803983222',
        'label': 'خودرو2'
    }, { 'value': '63380098535169030', 'label': 'قنیشا' }, {
        'value': '17933573078185644',
        'label': 'آینده'
    }, { 'value': '35178706978554988', 'label': 'شپاس' }, {
        'value': '39807886630843041',
        'label': 'بمپنا'
    }, { 'value': '5564768007356822', 'label': 'حریل' }, {
        'value': '54715710303837090',
        'label': 'گلدیرا'
    }, { 'value': '54277068923045214', 'label': 'فسرب' }, {
        'value': '12387472624849835',
        'label': 'داسوه'
    }, { 'value': '36235343945196457', 'label': 'وفردا' }, {
        'value': '41048299027409941',
        'label': 'رتاپ'
    }, { 'value': '7235435095059069', 'label': 'پکویر' }, {
        'value': '28809886765682162',
        'label': 'حفاری'
    }, { 'value': '5599691633622269', 'label': 'بخاور' }, {
        'value': '62258804563636993',
        'label': 'تکشا'
    }, { 'value': '44665761767777759', 'label': 'گکیش' }, {
        'value': '33293588228706998',
        'label': 'وپارس'
    }, { 'value': '57722642338781674', 'label': 'پلاسک' }, {
        'value': '49270349234092953',
        'label': 'خاور'
    }, { 'value': '15282093177363578', 'label': 'شساخت' }, {
        'value': '40611478183231802',
        'label': 'شدوص'
    }, { 'value': '23936607891892333', 'label': 'چافست' }, {
        'value': '11258722998911897',
        'label': 'وسکاب'
    }, { 'value': '54263829393913132', 'label': 'کمینا' }, {
        'value': '5987841496184505',
        'label': 'شگویا'
    }, { 'value': '50580753680043015', 'label': 'معیار ' }, {
        'value': '38555056423456635',
        'label': 'شتوکا'
    }, { 'value': '13227300125161435', 'label': 'سصوفی' }, {
        'value': '70474983732269112',
        'label': 'دپارس'
    }, { 'value': '22259718159702272', 'label': 'استقلال' }, {
        'value': '66450490505950110',
        'label': 'ددام'
    }, { 'value': '66142616039907394', 'label': 'دماوند' }, {
        'value': '10831074117626896',
        'label': 'قاروم'
    }, { 'value': '59266699437480384', 'label': 'ارفع' }, {
        'value': '56802926348928053',
        'label': 'ولیز'
    }, { 'value': '56429431740318486', 'label': 'شلرد' }, {
        'value': '50587892784913370',
        'label': 'حشکوه'
    }, { 'value': '66456062140680461', 'label': 'ثامان' }, {
        'value': '24807173016704795',
        'label': 'سباقر'
    }, { 'value': '22667016906590506', 'label': 'شبهرن' }, {
        'value': '69454539056549106',
        'label': 'بشهاب'
    }, { 'value': '28320293733348826', 'label': 'وبصادر' }, {
        'value': '36844527173896115',
        'label': 'زفجر'
    }, { 'value': '49399017998386087', 'label': 'فبیرا' }, {
        'value': '55979741213594029',
        'label': 'کباده'
    }, { 'value': '793710053482057', 'label': 'لپیام' }, {
        'value': '38437201078089290',
        'label': 'کرماشا'
    }, { 'value': '24254843881948059', 'label': 'چکاوه' }, {
        'value': '70883594945615893',
        'label': 'سآبیک'
    }, { 'value': '46830341954511303', 'label': 'وآیند' }, {
        'value': '57944184894703821',
        'label': 'والبر'
    }, { 'value': '24662567615903665', 'label': 'وسنا' }, {
        'value': '43342306308122676',
        'label': 'قمرو'
    }, { 'value': '18568733593280948', 'label': 'ثامید' }, {
        'value': '29316948750916349',
        'label': 'پلوله'
    }, { 'value': '47638138090419261', 'label': 'شفا2' }, {
        'value': '61332057061846617',
        'label': 'دابور'
    }, { 'value': '57309221039930244', 'label': 'وصنعت' }, {
        'value': '66210395067138534',
        'label': 'شتولی'
    }, { 'value': '22299894048845903', 'label': 'غگل' }, {
        'value': '60523145697836739',
        'label': 'بورس'
    }, { 'value': '69090868458637360', 'label': 'دیران' }, {
        'value': '11432067920374603',
        'label': 'دسینا'
    }, { 'value': '14957056743925737', 'label': 'خلنت' }, {
        'value': '35158826900216508',
        'label': 'غاذر'
    }, { 'value': '71758511001096824', 'label': 'غصینو' }, {
        'value': '45895339414786358',
        'label': 'خرینگ'
    }, { 'value': '71068313834275501', 'label': 'بگیلان' }, {
        'value': '5128151910501174',
        'label': 'وحافظ'
    }, { 'value': '63363116407864462', 'label': 'لابسا' }, {
        'value': '22490169030401337',
        'label': 'وآوا'
    }, { 'value': '14231831499205396', 'label': 'سنیر' }, {
        'value': '8646067353086740',
        'label': 'بالاس'
    }, { 'value': '48241092863917835', 'label': 'ولپارس' }, {
        'value': '24644999329120295',
        'label': 'وملل'
    }, { 'value': '23175320865252772', 'label': 'وسالت' }, {
        'value': '34557241988629814',
        'label': 'برکت'
    }, { 'value': '66514709341259550', 'label': 'فوکا' }, {
        'value': '64699417405634265',
        'label': 'نطرین'
    }, { 'value': '59470107928175959', 'label': 'گنگین' }, {
        'value': '25417476013479486',
        'label': 'ساروج'
    }, { 'value': '10114441830266109', 'label': 'گدنا' }, {
        'value': '33406621820337161',
        'label': 'دجابر'
    }, { 'value': '9536587154100457', 'label': 'وپاسار' }, {
        'value': '675737110292645',
        'label': 'فملی2'
    }, { 'value': '31959715133485440', 'label': 'ولقمان' }, {
        'value': '71744682148776880',
        'label': 'ولصنم'
    }, { 'value': '50247622569476338', 'label': 'بوعلی' }, {
        'value': '23891830829322971',
        'label': 'بایکا'
    }, { 'value': '40043919653526083', 'label': 'وثخوز' }, {
        'value': '204092872752957',
        'label': 'شصدف'
    }, { 'value': '3955332316338258', 'label': 'وطوبی' }, {
        'value': '34721884030854211',
        'label': 'سفاسی'
    }, { 'value': '5305844922895340', 'label': 'داوه' }, {
        'value': '66424163876658304',
        'label': 'ودانا'
    }, { 'value': '50100062518826135', 'label': 'دامین' }, {
        'value': '64358061873294912',
        'label': 'چفیبر'
    }, { 'value': '28957320033282870', 'label': 'چکاپا' }, {
        'value': '29860265627578401',
        'label': 'ما'
    }, { 'value': '30765727085936322', 'label': 'فجام' }, {
        'value': '35425587644337450',
        'label': 'فملی'
    }, { 'value': '17232252152159494', 'label': 'آواپارس' }, {
        'value': '41227201752535311',
        'label': 'سفار'
    }, { 'value': '33410001534682920', 'label': 'رفاه' }, {
        'value': '61469668095573716',
        'label': 'ولکار'
    }, { 'value': '34890845654517313', 'label': 'ساربیل' }, {
        'value': '25211433301660888',
        'label': 'خپارس'
    }, { 'value': '12174970951705823', 'label': 'شپدیس2' }, {
        'value': '52220424531578944',
        'label': 'سغرب'
    }, { 'value': '19040514831923530', 'label': 'نوری' }, {
        'value': '54509759694064219',
        'label': 'تپکو'
    }, { 'value': '70270965300262393', 'label': 'البرز' }, {
        'value': '13611044044646901',
        'label': 'ملت'
    }, { 'value': '4563413583000719', 'label': 'ساراب' }, {
        'value': '25514780181345713',
        'label': 'وساخت'
    }, { 'value': '64843936383937546', 'label': 'غگلستا' }, {
        'value': '4614779520007780',
        'label': 'کسرا'
    }, { 'value': '15259343650667588', 'label': 'قزوین' }, {
        'value': '37284308569715577',
        'label': 'فسبزوار'
    }, { 'value': '28854105556435129', 'label': 'ثزاگرس' }, {
        'value': '42599305106713939',
        'label': 'زکوثر'
    }, { 'value': '70934270174405743', 'label': 'شخارک' }, {
        'value': '21976566779427945',
        'label': 'شپنا2'
    }, { 'value': '40262275031537922', 'label': 'دروز' }, {
        'value': '9987529074833218',
        'label': 'آبین'
    }, { 'value': '27000326841257664', 'label': 'سدشت' }, {
        'value': '63917421733088077',
        'label': 'وتجارت'
    }, { 'value': '63481599728522324', 'label': 'ثشاهد' }, {
        'value': '18883380772506226',
        'label': 'ثرود'
    }, { 'value': '40808043719554948', 'label': 'فولاژ' }, {
        'value': '11560002870991149',
        'label': 'وپسا'
    }, { 'value': '6043384171800349', 'label': 'ثشرق' }, {
        'value': '59866041653103343',
        'label': 'نوین'
    }, { 'value': '1358190916156744', 'label': 'وآذر' }, {
        'value': '14073782708315535',
        'label': 'شنفت'
    }, { 'value': '50000663139125177', 'label': 'سلار2' }, {
        'value': '25001509088465005',
        'label': 'کساوه'
    }, { 'value': '43552974795606067', 'label': 'خراسان' }, {
        'value': '44986797317463049',
        'label': 'وثنو'
    }, { 'value': '23353689102956991', 'label': 'دکوثر' }, {
        'value': '408934423224097',
        'label': 'فرآور'
    }, { 'value': '17800036702302776', 'label': 'ثاخت' }, {
        'value': '33420285433308219',
        'label': 'زپارس'
    }, { 'value': '4470657233334072', 'label': 'سخاش' }, {
        'value': '48143530437185334',
        'label': 'شگویا2'
    }, { 'value': '20024911381434086', 'label': 'دکیمی' }, {
        'value': '19257295292088310',
        'label': 'خکمک'
    }, { 'value': '69143674941561637', 'label': 'پترول' }, {
        'value': '10236455588057352',
        'label': 'انتخاب'
    }, { 'value': '7505990056227818', 'label': 'ممسنی' }, {
        'value': '15472396110662150',
        'label': 'سکرما'
    }, { 'value': '49854144784855542', 'label': 'رتکو' }, {
        'value': '20560887114747719',
        'label': 'کسرام'
    }, { 'value': '30829203706095076', 'label': 'ستران' }, {
        'value': '5187018329202415',
        'label': 'لپارس'
    }, { 'value': '65122215875355555', 'label': 'شفن' }, {
        'value': '589599697502308',
        'label': 'وآفری'
    }, { 'value': '26259366519412975', 'label': 'زشگزا' }, {
        'value': '51017863148152520',
        'label': 'فرود'
    }, { 'value': '63580313877463104', 'label': 'پاسا' }, {
        'value': '65999092673039059',
        'label': 'مداران'
    }, { 'value': '15949743338644220', 'label': 'ساروم' }, {
        'value': '20487994977117557',
        'label': 'غشهد'
    }, { 'value': '27299841173245405', 'label': 'داراب' }, {
        'value': '36995197800118822',
        'label': 'سنوین'
    }, { 'value': '15039949673085566', 'label': 'پردیس' }, {
        'value': '59800986739603675',
        'label': 'شسم'
    }, { 'value': '47333458678352378', 'label': 'وخاور' }, {
        'value': '28845264556937486',
        'label': 'شپلی'
    }, { 'value': '49188729526980541', 'label': 'شسپا' }, {
        'value': '54676885047867737',
        'label': 'وتوشه'
    }, { 'value': '4758266259250794', 'label': 'خپویش' }, {
        'value': '53647874954005806',
        'label': 'واحصا'
    }, { 'value': '23049019886587905', 'label': 'خفولا' }, {
        'value': '55373808401388162',
        'label': 'فتوسا'
    }, { 'value': '25244329144808274', 'label': 'فارس' }, {
        'value': '22941065011246116',
        'label': 'کپرور'
    }, { 'value': '43966385447049549', 'label': 'ودی' }, {
        'value': '11773403764702778',
        'label': 'وبیمه'
    }, { 'value': '20865316761157979', 'label': 'فاراک' }, {
        'value': '18599703143458101',
        'label': 'امید'
    }, { 'value': '4507558419857064', 'label': 'زماهان' }, {
        'value': '65490886290565185',
        'label': 'شزنگ'
    }, { 'value': '62558705479545830', 'label': 'سایرا' }, {
        'value': '47841327496247362',
        'label': 'واعتبار'
    }, { 'value': '32525655729432562', 'label': 'سبهان' }, {
        'value': '46801030346547943',
        'label': 'دقاضی'
    }, { 'value': '19310456400689867', 'label': 'خبازرس' }, {
        'value': '10843114830116591',
        'label': 'نبروج'
    }, { 'value': '4528607775462304', 'label': 'سفانو' }, {
        'value': '60247433951600827',
        'label': 'شاوان'
    }, { 'value': '6116572045021585', 'label': 'شجم' }, {
        'value': '26316376625263940',
        'label': 'پی پاد'
    }, { 'value': '32257753560585502', 'label': 'کحافظ' }, {
        'value': '25286509736208688',
        'label': 'فلامی'
    }, { 'value': '10024128313803797', 'label': 'زگلدشت' }, {
        'value': '30231789123900526',
        'label': 'نمرینو'
    }, { 'value': '7628308021169118', 'label': 'بکهنوج' }, {
        'value': '38547060135156069',
        'label': 'فاذر'
    }, { 'value': '44153164692325703', 'label': 'شگل' }, {
        'value': '69540585676934415',
        'label': 'ددانا'
    }, { 'value': '68941822863885255', 'label': 'رافزا' }, {
        'value': '39884565732277052',
        'label': 'کیمیاتک'
    }, { 'value': '3407806799514469', 'label': 'شاروم' }, {
        'value': '65321970913593427',
        'label': 'سکرد'
    }, { 'value': '60887982279284651', 'label': 'ثجنوب' }, {
        'value': '43362635835198978',
        'label': 'های وب'
    }, { 'value': '17939384202383793', 'label': 'ثغرب' }, {
        'value': '29122854902865456',
        'label': 'کسعدی'
    }, { 'value': '20562694899904339', 'label': 'شپدیس' }, {
        'value': '35796086458096255',
        'label': 'شیران'
    }, { 'value': '71290297158948749', 'label': 'زقیام' }, {
        'value': '69904617508102874',
        'label': 'کارام'
    }, { 'value': '3492952121304423', 'label': 'غدیس' }, {
        'value': '58810336532668771',
        'label': 'کایزد'
    }, { 'value': '16777570760181431', 'label': 'کازرو' }, {
        'value': '9098178887955847',
        'label': 'شهر'
    }, { 'value': '23086515493897579', 'label': 'ولغدر' }, {
        'value': '41974758296041288',
        'label': 'سخوز'
    }, { 'value': '56591881518499520', 'label': 'وسین' }, {
        'value': '43023243844297350',
        'label': 'چنوپا'
    }, { 'value': '37089148943784077', 'label': 'خبنیان' }, {
        'value': '36282416082320053',
        'label': 'والماس'
    }, { 'value': '48623320733330408', 'label': 'فلوله' }, {
        'value': '41713045190742691',
        'label': 'وسدید'
    }, { 'value': '51106317433079213', 'label': 'آسیا' }, {
        'value': '71856634742001725',
        'label': 'سپ'
    }, { 'value': '9481703061634967', 'label': 'پارسیان' }, {
        'value': '15962072736526551',
        'label': 'کاریز'
    }, { 'value': '3654864906585643', 'label': 'تکنو' }, {
        'value': '28325731560106431',
        'label': 'کساپا'
    }, { 'value': '47702059190622416', 'label': 'ثتوسا' }, {
        'value': '69817338460284329',
        'label': 'فروژ'
    }, { 'value': '32678431934327184', 'label': 'کلوند' }, {
        'value': '54369290104873523',
        'label': 'بتک'
    }, { 'value': '43622578471330344', 'label': 'دسبحا' }, {
        'value': '49502666250908008',
        'label': 'افق'
    }, { 'value': '10120557300120078', 'label': 'پسهند' }, {
        'value': '19471788163911687',
        'label': 'کفپارس'
    }, { 'value': '25631699615003698', 'label': 'کهرام' }]

    const { updateSelectedSymbols, updateSearchSymbol } = useContext(Context);
    const [selectedSymbols, setSelectedSymbols] = useState([]);
    const handleSelectChange = (selectedValues) => {
        setSelectedSymbols(selectedValues);
        if (selectedValues.length > 0) {
            updateSearchSymbol(selectedValues[0]['label'])

        } else {
            updateSearchSymbol('')
        }
    };

    const onClick = ((event) => {
        event.preventDefault()
        updateSelectedSymbols(selectedSymbols)
        updateSearchSymbol(null)
        setSelectedSymbols([])
        alert('نمادهای انتخاب شده به واچ لیست اضافه شده')
    })
    return (
        <>
            <Select
                isMulti
                options={options}
                name='symbols'
                className="w-100"
                value={selectedSymbols}
                onChange={handleSelectChange}
                placeholder=" انتخاب کنید..."
                isOptionDisabled={() => selectedSymbols.length >= 1}
            />
            <div className="d-flex mx-lg-2 mx-2">
                <button disabled={selectedSymbols.length === 0} onClick={onClick}
                    className="btn btn-success px-lg-3 p-2 fs-lg-6 fnt-12" id="AddBtn">
                    {props.buttonName}
                </button>
            </div>
        </>
    )
        ;
}

export function ShowSelectedToggle() {
    const { contextData, updateShowSelectedSymbols } = useContext(Context);

    const onChange = (() => {
        updateShowSelectedSymbols();
    })

    return (
        <>
            <label className="form-check-label text-white mx-2">همه</label>
            <div className="form-check form-switch">
                <input checked={contextData.showSelectedSymbols} onChange={onChange} className="form-check-input"
                    type="checkbox" />
                <label className="form-check-label text-white" htmlFor="rowFilter">نمایش سبد</label>
            </div>
        </>
    )
}

export function TrendToggle() {
    const { contextData, updateTrend } = useContext(Context);

    const onChange = ((event) => {
        updateTrend(event.target.value);
    })

    return (
        <>
            <select className="form-select" aria-label="Default select example" onChange={onChange}>
                {
                    [
                        { value: "1", label: "همه" },
                        { value: "2", label: "خرید" },
                        { value: "3", label: "فروش" }
                    ].map(option => (
                        <option key={option.value} value={option.value}
                            defaultValue={contextData.trend}>{option.label}</option>
                    ))}
            </select>
        </>
    )
}

export function CommentForm(props) {
    const initialData = props.initialData
    const [input, setInput] = useState({
        related_object_id: props.related_object_id,
        content_type: props.content_type_id,
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [message, setMessage] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [authenticated, setAuthenticated] = useState(null)
    const currentUrl = new URL(window.location.href)
    const redirectUrl = `${getUrl().REACT_APP_LOGIN}?next=${currentUrl.pathname}`


    async function fetchAuthData() {

        const url = getUrl().REACT_APP_CSRF_TOKEN
        try {
            const response = await fetch(
                url,
                {
                    credentials: 'include',
                }
            )
            if (response.ok) {
                const json_response = await response.json()
                setAuthenticated(json_response['is_authenticated'])
                setLoading(false)
                return json_response;
            } else {
                setError(true)
                return null
            }
        } catch (e) {
            setError(true)
            return null
        }
    }

    useEffect(() => {
        fetchAuthData()
    }, [refresh]);


    const handleInput = event => {
        setInput({
            ...input,
            [event.target.name]: event.target.value
        })
    }
    const onSubmit = async (event) => {
        event.preventDefault();

        const csrfTokenFetchResponse = await fetchAuthData()
        if (csrfTokenFetchResponse === null) {
            setError(true)
        } else if (csrfTokenFetchResponse === false) {
            setAuthenticated(false)
        } else {
            const csrfToken = csrfTokenFetchResponse['csrf_token']
            const url = initialData ? getUrl().REACT_APP_COMMENT_UPDATE.replace(/{id}/g, initialData.id) : getUrl().REACT_APP_COMMENT_CREATE
            const response = await fetch(url, {
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify(input),
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                },
            });

            if (response.ok) {
                setMessage(true)
                setLoading(false)
            } else if (response.status === 302) {
                setAuthenticated(false)
            } else {
                setError(true)
            }
        }
    };

    const errorDiv =
        <Alert show={error} variant="danger">
            <h4>
                خطای ارتباط با سرور
            </h4>
            <hr />
            <div className="d-flex justify-content-end">
                <Button onClick={() => {
                    setLoading(true)
                    setError(false)
                    setInterval(() => {
                        setLoading(false)
                    }, 1500)
                    setRefresh(!refresh)

                }} variant="outline-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                        fill="none"
                        stroke="#0c0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path
                            d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                    </svg>
                </Button>
            </div>
        </Alert>


    const messageSentDiv =
        (message
            ?
            <Alert show={message} variant="success">
                <Alert.Heading>کاربر گرامی</Alert.Heading>
                <p>
                    پیام با موفقیت ارسال شد و بعد از تایید منتشر می شود.
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                    <Button onClick={() => setMessage(false)} variant="outline-success">
                        خروج
                    </Button>
                </div>
            </Alert>
            :
            null
        )
    const formDiv = authenticated === null
        ?
        errorDiv
        :
        authenticated === false
            ?
            <p>برای ارسال درخواست لطفا <a href={redirectUrl}>وارد</a> سایت شوید</p>
            :
            <>
                {messageSentDiv}
                <form method="post"
                    onSubmit={onSubmit}
                    className="form mb-15 fv-plugins-bootstrap5 fv-plugins-framework"
                    id="kt_contact_form">
                    <div className="d-flex flex-column mb-10 fv-row fv-plugins-icon-container">
                        <label className="fs-6 fw-bold mb-5 required">توضیحات درخواست</label>

                        <textarea name="body" id="id_body" cols="40" rows="10" required
                            className="form-control form-control-solid"
                            onChange={handleInput}
                            defaultValue={initialData ? initialData.body : ''}
                        />
                        <div className="fv-plugins-message-container invalid-feedback" />
                    </div>
                    {/*<div className="d-flex flex-column mb-10 fv-row fv-plugins-icon-container ">*/}
                    {/*    /!*{{form.captcha}}*!/*/}
                    {/*    <span className="text-danger">*/}
                    {/*        /!*{{form.captcha.errors}}*!/*/}
                    {/*    </span>*/}
                    {/*    <div className="fv-plugins-message-container invalid-feedback"/>*/}
                    {/*</div>*/}
                    <div className="d-flex flex-column mb-10 fv-row fv-plugins-icon-container">
                        <button type="submit" className="btn btn-primary" id="kt_contact_submit_button">
                            <span className="indicator-label">ارسال</span>

                        </button>
                        <div className="fv-plugins-message-container invalid-feedback" />
                    </div>
                </form>
            </>
    return (
        <div className="mb-7">
            {
                loading
                    ?
                    (
                        <LoadingSpinner />
                    )
                    :
                    error || authenticated === null
                        ?
                        errorDiv
                        :
                        formDiv
            }
        </div>

    )
}

export function SelectFilterStock() {

    const { contextData, updateSelectedStocks } = useContext(Context);
    //     {'id': JSON.stringify([300]), 'filter': "stock", 'name': " سهام بورس"},
    //     {'id': JSON.stringify([303,313]), 'filter': 'stock', 'name': ' فرابورس'},
    //     {'id': JSON.stringify([309]), 'filter': 'stock', 'name': ' بازار پایه'},
    //     {'id': JSON.stringify([305, 380]), 'filter': 'stock', 'name': ' صندوق سرمایه گذاری'}
    //     {'id': JSON.stringify([300]), 'filter': "stock", 'name': " سهام بورس"},
    //     {'id': JSON.stringify([303,313]), 'filter': 'stock', 'name': ' فرابورس'},
    //     {'id': JSON.stringify([309]), 'filter': 'stock', 'name': ' بازار پایه'},
    //     {'id': JSON.stringify([305, 380]), 'filter': 'stock', 'name': ' صندوق سرمایه گذاری'},
    //     {'id': JSON.stringify([400, 403, 404]), 'filter': 'stock', 'name': ' حق تقدم'},
    //     {'id': JSON.stringify(['block']), 'filter': 'l18', 'name': ' معاملات بلوکی'},
    //     {'id': JSON.stringify([311, 320]), 'filter': 'stock', 'name': ' اختیار خرید'},
    //     {'id': JSON.stringify([312, 321]), 'filter': 'stock', 'name': ' اختیار فروش'},
    //     {'id': JSON.stringify([307]), 'filter': 'stock', 'name': ' تسهیلات مسکن'},
    //     {'id': JSON.stringify([600]), 'filter': 'stock', 'name': ' بورس کالا'},
    //     {'id': JSON.stringify(['all']), 'filter': '', 'name': ' همه'},

    const options = [
        { 'id': 300, 'filter': "stock", 'name': " سهام بورس", 'default': true },
        { 'id': 303, 'filter': 'stock', 'name': ' فرابورس', 'default': true },
        { 'id': 309, 'filter': 'stock', 'name': ' بازار پایه', 'default': true },
        { 'id': 305, 'filter': 'stock', 'name': ' صندوق سرمایه گذاری', 'default': true },
        { 'id': 400, 'filter': 'stock', 'name': ' حق تقدم', 'default': false },
        { 'id': 'block', 'filter': 'l18', 'name': ' معاملات بلوکی', 'default': false },
        { 'id': 311, 'filter': 'stock', 'name': ' اختیار خرید', 'default': false },
        { 'id': 312, 'filter': 'stock', 'name': ' اختیار فروش', 'default': false },
        { 'id': 307, 'filter': 'stock', 'name': ' تسهیلات مسکن', 'default': false },
        { 'id': 600, 'filter': 'stock', 'name': ' بورس کالا', 'default': false },
    ]
    const onChange = (selectedItems) => {
        updateSelectedStocks(selectedItems)
    }
    return (
        <Multiselect
            options={options}
            selectedValues={contextData['selectedStocks'] === null ? options.filter(option => { return option.default }) : contextData['selectedStocks']}
            onSelect={onChange}
            onRemove={onChange}
            displayValue="name"
            showCheckbox={true}
            hideSelectedList={true}
            placeholder="نوع اوراق"
            className="multiselect"
            avoidHighlightFirstOption={true}
            style={
                {
                    chips: {
                        background: 'rgb(59, 108, 233)',
                        color: '#fff'
                    },
                    multiselectContainer: {

                        color: 'red'
                    },
                    searchBox: {
                        'borderRradius': '4px',
                        'marginRight': '10px',
                        'background': 'white'
                    },
                    placeholder: {
                        'color': 'black'
                    }
                }
            }

        />
    )
}